import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    kpiType = -1,
    industryId = '',
    depIds = [],
    auditState = -1,
    publishState = 0,
    pi = 1,
    ps = 50,
    order = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpi.getPage, {
        search,
        kpiType,
        industryId,
        depIds,
        auditState,
        publishState,
        pi,
        ps,
        order,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pc: 0, pi, ps };
};
